import {Record,List} from 'immutable';
import {ReduxHelpers} from 'Redux/ReduxHelpers';
import {SetActiveDataframesAction, GetCrashDataframesSuccessAction,SetCollisionsListAction, SetActiveCollisionAction,SetCollisionToken} from '../Actions/Models/CollisionActionModel';
import {HistoryCollisionStore} from '../../Models/CollisionModel';
import moment from 'moment';

export const HistoryCollisionState = Record<HistoryCollisionStore>({
    dataframesSpeed:List(),
    dataframesAcceleration:List(),
    activeDataframes:null,
    crashMoment:null,
    collisionList:List(),
    activeCollision:null,
    collisionToken:null,
    carCollision:null,
});

export class CollisionReducer extends HistoryCollisionState {
    public initAction(data:any) {
        return this.merge(data);
    }

    public setCollisionDataframes(action:GetCrashDataframesSuccessAction):CollisionReducer {
        return this.set('dataframesSpeed',List(action.payload.dataframesSpeed))
        .set('dataframesAcceleration',List(action.payload.dataframesAcceleration))
        .set('crashMoment',moment(action.payload.crashDataframe.dateTime))
        .set('carCollision',action.payload.carCollision)
    }

    public setActiveDataframes(action:SetActiveDataframesAction):CollisionReducer {
        return this.set('activeDataframes',action.payload.activeDataframes)
    }

    public setCollisionsList(action:SetCollisionsListAction):CollisionReducer {
        return this.set('collisionList',List(action.payload.collisionList)) 
    }

    public setActiveCollision(action:SetActiveCollisionAction):CollisionReducer {
        return this.set('activeCollision',action.payload.collisionId);
    }

    public setCollisionToken(action:SetCollisionToken):CollisionReducer {
        return this.set('collisionToken',action.payload.collisionToken);
    }
}

export type HistoryCollisionState = HistoryCollisionStore;


export const historyCollisionReducer = ReduxHelpers.newReducerFromRecordClass(CollisionReducer);



// WEBPACK FOOTER //
// ./src/Redux/Reducers/CollisionReducer.ts